const getter = {
    menuArr: (state: any)=> state.menu.menuArr,
    userData: (state: any) => state.user.userData
}
export default getter
